var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRule(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2796 8.61014C13.2796 11.9398 10.9488 13.6046 8.17857 14.5702C8.03351 14.6193 7.87593 14.617 7.7324 14.5635C4.95549 13.6046 2.62476 11.9398 2.62476 8.61014V3.94867C2.62476 3.77205 2.69492 3.60267 2.8198 3.47779C2.94469 3.3529 3.11407 3.28274 3.29068 3.28274C4.62253 3.28274 6.28734 2.48363 7.44605 1.47143C7.58713 1.35089 7.7666 1.28467 7.95216 1.28467C8.13771 1.28467 8.31718 1.35089 8.45826 1.47143C9.62363 2.49029 11.2818 3.28274 12.6136 3.28274C12.7902 3.28274 12.9596 3.3529 13.0845 3.47779C13.2094 3.60267 13.2796 3.77205 13.2796 3.94867V8.61014Z",
    stroke: "#90A1B9",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95438 7.94415L7.28623 9.276L9.94993 6.6123",
    stroke: "#90A1B9",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRule);
export default __webpack_public_path__ + "static/media/rule.a36db46a7417dae47da84a271228804d.svg";
export { ForwardRef as ReactComponent };